import React from 'react';
const UserAvatar = ({
  user
}) => {
  const getInitials = () => {
    if (!user.name) return '?';
    return user.name.split(' ').map(name => name[0]).join('').toUpperCase().substring(0, 2);
  };
  return <div className="relative w-8 h-8 overflow-hidden bg-[#1649ff] rounded-full flex items-center justify-center" data-id="element-512">
      {user.avatar ? <img src={user.avatar} alt={user.name || 'User'} className="w-full h-full object-cover" data-id="element-513" /> : <span className="text-sm font-medium text-white" data-id="element-514">{getInitials()}</span>}
    </div>;
};
export default UserAvatar;